/* global SideDrawer, debounce, initLazyImages */

if (!customElements.get('facet-filters')) {
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);

      if (this.breakpointChangeHandler) {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }
    }

    init() {
      this.form = document.getElementById('facets');
      this.results = document.getElementById('filter-results');
      this.selectors = this.querySelectorAll('select');
      this.inputs = this.querySelectorAll('input');

      this.selectors.forEach(select => {
        select.onchange = this.getData;
      })

      this.inputs.forEach(input => {
        input.onchange = this.getData;
      })

      console.log(this.form);
    }

async getData() {
  let formData = new FormData(this.form);
  let searchParams = new URLSearchParams(formData);
  let queryString = searchParams.toString();

  // Find the position of "&q=" in the search string, if it exists
  let qParamIndex = window.location.search.indexOf('&q=');

  let searchUpToFirstAmpersand;
  if (qParamIndex !== -1) {
    // Find the next ampersand after "&q=" if it exists
    let nextAmpersandIndex = window.location.search.indexOf('&', qParamIndex + 1);
    if (nextAmpersandIndex !== -1) {
      // Use the part of the search string up to the next ampersand after "&q="
      searchUpToFirstAmpersand = window.location.search.substring(0, nextAmpersandIndex);
    } else {
      // If there's no next ampersand, use the entire search string
      searchUpToFirstAmpersand = window.location.search;
    }
  } else {
    // If "&q=" is not found, split at the first "&"
    searchUpToFirstAmpersand = window.location.search.split('&')[0];
  }

  if (location.pathname.includes('search')) {
    var fetchString;
    if (searchUpToFirstAmpersand) {
      // Use searchUpToFirstAmpersand if it exists
      fetchString = `${window.location.pathname}${searchUpToFirstAmpersand}&${queryString}`;
    } else {
      // Directly append queryString if searchUpToFirstAmpersand is empty
      fetchString = `${window.location.pathname}?${window.location.search}&${queryString}`;
    }
  } else {
    var fetchString = `${window.location.pathname}?${queryString}`;
  }

  document.getElementById('filter-results').classList.add('loading');
  const response = await fetch(fetchString);
  if (response.ok) {
    const html = await response.text();
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(html, "text/html");
    document.getElementById('filter-results').innerHTML = htmlDoc.getElementById('filter-results').innerHTML;
    document.getElementById('filter-results').classList.remove('loading');
    window.history.pushState({}, '', fetchString);
  }
}

  }

  customElements.define('facet-filters', FacetFilters);
}
 